<template>
    <div class="grid">
        <div class="card col-12 mainTitle">
            <h3 class="stationsHeader">{{ translated('titleposete').toUpperCase() }}</h3>       
            <Button
                @click="helpVisible=!helpVisible"
                icon="pi pi-question"
                :label="ponocString"
                class="helpButton p-button-rounded">
            </Button>         
        </div>

        <div class="card col-12 helpSection" v-if="helpVisible">
            <div class="sekcijaOpis">
                Pregled svih poseta je prikazan hronološkim redosledom, pri čemu je poslednje uneta poseta na vrhu stranice, a najstarija na dnu spiska. Iznad tabele nalazi se polje za unos teksta koje omogućava pretragu laboratorijskih izveštaja.
            </div>

            <div><br/><b>Opis kolona:</b></div>
            <ul>
                <li><b>Kolona 1:</b> U ovoj koloni prikazuje se crveni simbol "+", koji označava da je pored standardne posete kreirana i kućna poseta.</li>
                <li><b>Kolona 2:</b> Prikazuje ime i prezime osobe koja dolazi u laboratoriju.</li>
                <li><b>Kolona 3:</b> Datum kada je poseta kreirana.</li>
                <li><b>Kolona 4:</b> Trenutni status posete.</li>
                <li><b>Kolona 5:</b> Datum poslednje promene statusa.</li>
                <li><b>Kolona 6:</b> Ukupna cena analiza.</li>
            </ul>
        </div>

        <DataTable stateStorage="local" stateKey="dt-state-locations-session" :value="allanalysis" :paginator="true" class="p-datatable-allanalysis" :rows="24"
            dataKey="id" :rowHover="true" v-model:filters="filters1" filterDisplay="menu" :loading="isLoading" :rowClass="rowClass"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
            currentPageReportTemplate="Prikaz {first} do {last} od {totalRecords} analiza"
            :globalFilterFields="['name','surname']" responsiveLayout="scroll"  @row-click="onRowClick">
            
            <template #header>
                <div class="p-d-flex p-jc-between searchPlaceholder">
                    <span class="p-input-icon-right">
                        <i class="pi pi-search" />
                        <InputText ref="searchInput" v-model="rawFilterInput" :placeholder="this.translated('keywordsearch')" @focus="selectAllText"/>
                        <!-- v-model="filters1['global'].value" -->
                    </span>
                </div>
            </template>
            <template #empty>
                {{ translated('norecordsfound') }}
            </template>
            <template #loading>
                {{ translated('loadingdata') }}
            </template>
            <Column v-if="screenWidth >= 600" header="" :sortable="false" headerStyle="text-align: center" bodyStyle="text-align: center">
                 <template #body="slotProps">
                    <i v-if="slotProps.data.linked" class="pi pi-plus-circle bold-icon" style="color: #c51820"></i>                
                </template>
            </Column>

            <Column :header="translated('requestdate')" :sortable="false" headerStyle="text-align: center" bodyStyle="text-align: center">
                <template #body="slotProps">
                    {{ formatDate(slotProps.data.requestDate) }}
                </template>
            </Column>

            <Column :header="translated('namesurname')" :sortable="false" headerStyle="text-align: left" bodyStyle="text-align: left">
                <template #body="slotProps">
                    {{ slotProps.data.name + ' ' +slotProps.data.surname}}                  
                </template>            
            </Column>

            <Column :header="translated('status')" :sortable="false" headerStyle="text-align: center" bodyStyle="text-align: center">
                <template #body="slotProps">
                    {{ translated('analysisStatus_' + slotProps.data.status) }}
                </template>
            </Column>

            <Column v-if="screenWidth >= 600" :header="translated('laststatuschange')" :sortable="false" headerStyle="text-align: center" bodyStyle="text-align: center">
                <template #body="slotProps">
                    {{ formatDate(slotProps.data.lastStatusChange) }}
                </template>
            </Column>

            <!-- <Column :header="translated('totalprice')" :sortable="false" headerStyle="text-align: center" bodyStyle="text-align: center">
                <template #body="slotProps">
                    {{formatCurrency(slotProps.data.totalPrice)}}
                </template>
            </Column> -->

            <!-- <Column v-if="screenWidth >= 500" :header="translated('paid')" :sortable="false" headerStyle="text-align: center" bodyStyle="text-align: center">                 -->
            <Column v-if="screenWidth >= 600" :sortable="false" headerStyle="text-align: center" bodyStyle="text-align: center">                 
                <template #body="slotProps">
                    <!-- {{ translated('paid_' + slotProps.data.paid) }} -->
                    <i v-if="slotProps.data.paid" class="pi pi-credit-card payedIcon"></i>
                </template>
            </Column> 
            
            <Column v-if="screenWidth >= 600" headerStyle="width: 3em"  bodyStyle="text-align: center">
                <template #body="{data}">
                    <router-link :to="{ name: 'AnalysisReview', params: { id: data.id}}"> 
                        <Button icon="pi pi-info-circle" style="background-color:#0d89ec" class="p-button-raised p-button-secondary p-button-blue" />
                    </router-link>
                </template>
            </Column> 
        </DataTable>
	</div>
</template>

<script>
import createHttp from "@/services/http";
import router from "@/router/index";
import { computed, watch } from "vue"
import store from "@/store";
import {FilterMatchMode} from 'primevue/api';
import 'primeicons/primeicons.css';

export default {
    components: { },
    data() {
        return {
            rawFilterInput : '',
            isLoading : true,
            allanalysis : [],
            filters1: null,
            translated: computed(() => store.getters.getTranslate),
            screenWidth: 0,
            helpVisible: false
        }
    },
    created() {
      this.initFilters1();
    },
    computed: {
        ponocString() {
            return this.translated('translatedHelp');
        }
    },
    watch: {
        rawFilterInput(newValue) {
            this.filters1.global.value = this.normalizeInput(newValue);
        }
    },    
    async mounted() {
        const http = createHttp(true); 
        const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetAllAnalysisRequests");

        if(result.status==200){
            debugger;
            this.allanalysis = result.data;
        }

        this.screenWidth = window.innerWidth;
        window.addEventListener('resize', this.updateScreenWidth);


        this.$nextTick(() => {
            // console.log('Next TICK:', this.$refs.searchInput.$el);
            const input = this.$refs.searchInput.$el;
            if (input) {
                input.focus();
                input.select();
            } 
        });  

        this.isLoading = false;
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateScreenWidth);
    },
    methods: {
        normalizeInput(input) {
            const trimmed = input.trim();
            return trimmed === '' ? null : trimmed;
        },
        rowClass(data) {
            // // console.log('LINKED: ', data.linked);
            return [{ 'bg-linked': data.linked === 1 }];
        },
        selectAllText(event) {
            // Using $nextTick to ensure that the selection occurs after the input field is focused
            this.$nextTick(() => {
                event.target.select();
            })
        },
        onRowClick(event) {  
            const rowData = event.data;
            // console.log('ROW DATA: ',rowData);        
            this.$router.push({ name: 'AnalysisReview', params: { id: rowData.id } });
        },
        formatDate(value) {
            if(value != null){
                let myDate = new Date(value);
    
                return myDate.toLocaleDateString('ro-Ro');
            }
        },
        // formatCurrency(value) {
        //     return value.toLocaleString('rs-RS', {style: 'currency', currency: 'RSD'});
        // },
        formatCurrency(value) {
            // return value.toLocaleString('rs-RS', {style: 'currency', currency: 'RSD'});
            let formatted = value.toLocaleString('rs-RS', {style: 'currency', currency: 'RSD'});
            formatted = formatted.replace(/(^\D*)(\d.*\d)(\D*$)/, "$2 $1").trim();
            return formatted;
        },
        analysisDetails() {
            router.push({ name: 'AnalysisReview', params: allanalysis.id })
        },
        clearFilter1() {
            this.initFilters1();
        },
        initFilters1() {
            this.filters1 = {
                global: {value: null, matchMode: FilterMatchMode.CONTAINS},
            };
        },
        hasHomeVisit() {
            debugger;
            if(this.isLinked == 1){
                return true;
            }
            return false;
        },
        updateScreenWidth() {
            this.screenWidth = window.innerWidth;
        }
    }
}
</script>

<style scoped>
.p-datatable-allanalysis { width: 100%; }
.p-input-icon-right i.pi.pi-search {margin-right: 5px;}

/deep/ tr.p-row-even.bg-linked {background-color: #eddcdd;}
</style>